import {
  SET_SELECTED_STATE,
  RESET_SELECTED_STATE,
  SET_SELECTED_HOSPITAL,
  SET_SPECIFIC_STATE_DATA,
  RESET_SPECIFIC_STATE_DATA,
} from "./hospital.actionTypes";
import { RESTORE_STATE_SNAPSHOT } from "../app/app.actionTypes";

const initialState = {
  hospitalData: [],
  selectedStateData: {
    state: "",
    hospitalCount: 0,
    abbreviation: "",
    hospitalsList: [],
  },
  selectedHospital: null,
  specificStateData: {},
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_STATE:
      return {
        ...state,
        selectedStateData: action.payload,
      };

    case RESET_SELECTED_STATE:
      return {
        ...state,
        selectedStateData: initialState.selectedStateData,
      };

    case SET_SELECTED_HOSPITAL:
      return {
        ...state,
        selectedHospital: action.payload,
      };

    case SET_SPECIFIC_STATE_DATA:
      return {
        ...state,
        specificStateData: action.payload,
      };

    case RESET_SPECIFIC_STATE_DATA:
      return {
        ...state,
        specificStateData: {},
      };

    case RESTORE_STATE_SNAPSHOT:
      return {
        ...state,
        ...(action.payload?.hospital || {}),
      };

    default:
      return state;
  }
};
